var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":{ name: _vm.routeLink, id:_vm.id, params: { id: _vm.id }}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }